<template>
  <div class="container-fluid current-sale-line">
    <div class="row">
      <div class="line-description-pane col-7">
        <h6 class="line-description">
          {{ $utils.toPascalCase($utils.cutLength(saleLine.Description, 30)) }}<br>
        </h6>

        <button type="button" id="discount-btn" class="btn btn-outline-info text-sm" @click="discount">
          Add Discount
          <font-awesome-icon icon="percent"/>
        </button>

        <button type="button" style="display: none" data-bs-toggle="modal" :id="`discountCheck-${saleLine.index}-${uuid}`" :data-bs-target="`#discountModal-${saleLine.index}-${uuid}`"></button>

        <div class="modal fade" :id="`discountModal-${saleLine.index}-${uuid}`" tabindex="-1"
             :aria-labelledby="`discountModal-${saleLine.index}Label-${uuid}`" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" :id="`discountModal-${saleLine.index}Label-${uuid}`">
                  Apply Discount to {{ $utils.toPascalCase($utils.cutLength(saleLine.Description, 30)) }}
                </h5>
                <button type="button" class="btn-close" :id="`closeBTN-${saleLine.index}-${uuid}`" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <form >
                <div class="d-flex flex-row p-1 justify-content-evenly mt-2">
                  <label>
                    <input class="form-check-input" type="radio" value="value" v-model="discountType">
                    Value Discount
                  </label>
                  <label>
                    <input class="form-check-input" type="radio" value="percent" v-model="discountType">
                    Percentage Discount
                  </label>
                </div>
                <hr class="mx-2" />
                <label class="row mx-3 mb-2">
                  Discount Amount
                  <input type="number" class="form-control" v-model="discountAmount">
                </label>
              </form>
              <div class="modal-footer mt-3">
                <a class="btn btn-secondary" data-bs-dismiss="modal">Close</a>
                <a class="btn btn-primary" @click="applyDiscount">Save changes</a>
              </div>
            </div>
          </div>
        </div>

        <button @click="voidItem(saleLine)">
          <font-awesome-icon icon="trash" style="color: red"/>
        </button>
        <h5 class="text-success text-sm " v-if="saleLine.Discount>0">{{
            `Discount ${$utils.formatMoney(saleLine.Discount)}`
          }}</h5>
      </div>
      <div class="d-flex flex-column justify-content-between line-prices-pane col-5">
        <CurrentSaleQty :saleLine="saleLine" />
        <div class="price-row">
          <p class="price-label">Item Price: <span
              class="line-price">{{ $utils.formatMoney(saleLine.Unit, 2, '.', ',', false) }}</span></p>
          <p class="price-label">Total: <span
              class="line-price">{{ $utils.formatMoney((saleLine.Unit * saleLine.Qty) - saleLine.Discount + instructionTotal, 2, '.', ',', false) }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <ul class="cooking-instruction-list" v-if="hasInstructions">
        <li class="cooking-instruction-list-item" v-for="instruction in instructions">
          {{ instruction.CookingMsg }} <span>{{ instruction.count }} X {{
            $utils.formatMoney(instruction.Price)
          }}</span>
          Total: {{ $utils.formatMoney(instruction.count * instruction.Price) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CurrentSaleQty from "@/components/point-of-sale/sales/CurrentSaleQty";
import LineSeparator from "@/components/layout/utils/LineSeparator";

export default {
  name: "CurrentSaleLine",
  components: {LineSeparator, CurrentSaleQty},
  data(){
    return {
      discountType : 'value',
      discountAmount : 0.00,
      uuid : generateUUID(),
    }
  },
  props: {
    saleLine: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasInstructions() {
      return (this.saleLine.instructions && this.saleLine.instructions.length > 0)
    },
    instructionTotal() {
      if (!this.saleLine.instructions || this.saleLine.instructions.length === 0) return 0.00;
      let total = this.saleLine.instructions.map(i => i.Price * i.count).reduce((acc, n) => Number(n) + Number(acc))
      if (isNaN(total)) {
        return 0.00;
      }
      return Number(total.toFixed(2))
    },
    instructions() {
      return this.saleLine.instructions.map((int) => {
        int.Price = Number(int.Price.toFixed(2))
        return int;
      });
    }
  },
  methods: {
    voidItem(item) {
      this.$store.commit(`setOverrideDetails`,`Void Line (${item.Description})`)
      this.$store.commit('voidLine', item)
    },
    async discount() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`,`Discount`)
      if (!isAllowed) return ;
      document.getElementById(`discountCheck-${this.saleLine.index}-${this.uuid}`).click();
    },
    applyDiscount() {
      let type = this.discountType;
      let line = Number(this.saleLine.Unit) * Number(this.saleLine.Qty);
      let discount = Number(this.discountAmount);
      if (type === `percent`) discount = (this.discountAmount/100) * line;
      this.saleLine.Discount = discount;
      this.saleLine.Line = Number(this.saleLine.Line) - discount;
      document.getElementById(`closeBTN-${this.saleLine.index}-${this.uuid}`).click();
    }
  }
}
</script>

<style lang="scss" scoped>
.current-sale-line {
  padding: 5px;
  min-height: 95px;

  .row {
    .line-description-pane {
      .line-description {
        font-size: 18px;
        margin: 0;
        line-height: 18px;
        font-weight: 500;
      }
    }

    .line-prices-pane {
      .price-label {
        font-size: 12px;
        margin: 0;

        .line-price {
          font-size: 15px;
          font-weight: 700;
        }
      }
    }
  }
}

button {
  background-color: transparent;
}

.cooking-instruction-list {
  list-style: inside;

  .cooking-instruction-list-item {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: #404040;
    display: flex;
    justify-content: space-between;
  }
}

.price-row {
  display: flex;
  flex-direction: row;
}

.text-sm{
  font-size: 12px;
}
#discount-btn {
  padding: 2px;
  border-radius: 5px;
}
</style>
